import MyStorages from './MyStorages';
import TrackingProgress from './TrackingProgress';
import AdsCarousel from './AdsCarousel';
import InformationCarousel from './InformationCarousel';
import AcademyCarousel from './AcademyCarousel';

const Fragments = {
  MyStorages,
  TrackingProgress,
  AdsCarousel,
  InformationCarousel,
  AcademyCarousel,
};

export default Fragments;
